import HowWeSupport from "./HowWeSupport";

export default HowWeSupport;
